import { Address } from '@models/address'

export function formatAddress(address?: Address) {
  if (address) {
    // Convert addresses to lowercase excluding cardinal directions and state abbreviations
    const cardinalDirections = ['N', 'S', 'E', 'W', 'NW', 'NE', 'SW', 'SE']
    let cityStreet = `${address.street ?? address.address}, ${address.city}`
    let elements = cityStreet.split(' ')

    for (let i = 0; i < elements.length; i++) {
      if (cardinalDirections.includes(elements[i])) {
        elements[i] = elements[i]
      } else {
        elements[i] =
          elements[i][0] +
          elements[i].slice(1, elements[i].length).toLowerCase()
      }
    }

    cityStreet = elements.join(' ')

    return `${cityStreet}, ${address.state} ${
      address.zipCode ?? address.zip ?? ''
    }`
  }

  return ''
}
